import React from 'react';
import PageList from '../../components/PageListAPI'
import { moveProject } from '../../api/inventory'
import { getOurStorage } from '../../api/storage'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function InventoryMoveProject(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='position'
        columns={[
          { id: 'id', name: 'Номер' },
          { id: 'storageName', name: 'Склад' },
          { id: 'projectName', name: 'Проект' },
        ]}
        createItem={can(SLUGS.STORAGE.INVENTORY.MOVE_MANAGE)}
        deleteItem={can(SLUGS.STORAGE.INVENTORY.MOVE_MANAGE)}
        loadAPI={{
          request: moveProject.getList
        }}
        filterProps={[
          {
            type: 'autocomplite',
            path: getOurStorage.path,
            field: 'idStorage',
            name: 'Склад',
          },
        ]}
        click={false}
        deleteAPI={moveProject.deleteById}
        {...props}
      />
    </div>
  )
}